import { NicheFields, NicheFieldsNames } from "components/niches/NicheForm/NicheForm";

export const EDIT_NICHE_FIELDS: { [key in NicheFieldsNames]: NicheFields } = {
  [NicheFieldsNames.name]: {
    id: "name",
    label: "Name - Cannot be changed",
    placeholder: "My Niche Name!",
    errorMessage: "Give your niche a unique name",
    type: "text",
    disabled: true,
    value: "",
  },
  [NicheFieldsNames.description]: {
    id: "description",
    label: "Description",
    placeholder: "This is description of my niche",
    errorMessage: "Let other users know what this niche is about",
    rows: 3,
    value: "",
  },
  [NicheFieldsNames.rules]: {
    id: "rules",
    label: "Posting Guidelines",
    placeholder: "Be kind. Be honest. Be supportive",
    errorMessage: "Let other users know what is expected of them",
    rows: 5,
    value: "",
  }
};

type NicheValues = {
  name: string | null;
  rules: string | null | undefined;
  description: string | null;
}

export const getFieldsWithValues = (
  fields: { [key in NicheFieldsNames]: NicheFields },
  values: NicheValues
) => {
  const copyFields = { ...fields };

  Object.keys(values).forEach((key: string) => {
    copyFields[key as keyof NicheValues].value = values[key as keyof NicheValues] || "";
  });

  return copyFields;
};
